import { createSvgIcon } from '@mui/material';

export const BankIcon = createSvgIcon(
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.98438 14.8124V8.97903H6.65104V14.8124H4.98438ZM9.98438 14.8124V8.97903H11.651V14.8124H9.98438ZM2.48438 18.1457V16.479H19.151V18.1457H2.48438ZM14.9844 14.8124V8.97903H16.651V14.8124H14.9844ZM2.48438 7.31237V5.6457L10.8177 1.47903L19.151 5.6457V7.31237H2.48438ZM6.19271 5.6457H15.4427L10.8177 3.35403L6.19271 5.6457Z"
      fill="currentColor"
    />
  </svg>,
  'BankIcon',
);
